'use client';

import { useSyncExternalStore } from 'react';

import {
  subscribeTerminalWindow,
  terminalWindowIsOpen,
  terminalWindowIsOpenOnServer
} from '../helpers/terminalWindow';

/** Whether the terminal is out in a window of its own, so the board focuses it
 *  instead of opening a second view. An external store because the window
 *  announces itself on a channel every tab hears, including later ones. */
export function useDetachedTerminal(): boolean {
  return useSyncExternalStore(
    subscribeTerminalWindow,
    terminalWindowIsOpen,
    terminalWindowIsOpenOnServer
  );
}
